import { render, staticRenderFns } from "./DesignSelect.vue?vue&type=template&id=43b2c338&scoped=true&"
import script from "./DesignSelect.vue?vue&type=script&lang=js&"
export * from "./DesignSelect.vue?vue&type=script&lang=js&"
import style0 from "./DesignSelect.vue?vue&type=style&index=0&id=43b2c338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2c338",
  null
  
)

export default component.exports